<template>
  <div class="search-container">
    <el-row :gutter="20" class="search-row" style="display: flex; align-items: center">
      <!-- <el-col
        class="search-col"
        :xs="24"
        :sm="12"
        :md="12"
        :lg="3"
      >
        <el-row type="flex" style="align-items: center">
          <el-col :span="12">
            <span style="margin-right: 10px;">Mẫu</span>
            <input v-model="radioInput" type="radio" value="1">
          </el-col>
          <el-col :span="12">
            <span style="margin-right: 10px;">Đơn vị</span>
            <input v-model="radioInput" type="radio" value="2">
          </el-col>
        </el-row>
      </el-col> -->
      <el-col
        class="search-col"
        :xs="24"
        :sm="12"
        :md="12"
        :lg="8"
      >
        <el-input v-model="input" placeholder="Nhập thông tin" />
        <!-- <el-select placeholder="Select" :value="input">
          <el-option
            v-for="option in roomLevelList"
            :key="option.id"
            :label="option.name"
            :value="option.id"
          />
        </el-select> -->
      </el-col>
    </el-row>
    <el-row class="search-action" type="flex" justify="center">
      <el-button type="primary">Tìm kiếm</el-button>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      roomLevelList: [],
      input: '',
      radioInput: null
    }
  }
}
</script>
